<template lang="">
<div class="whatour">
    <div class="container">
      <h2>What our client say about us!</h2>
      <div class="whatour-main">
        <swiper
          :spaceBetween="30"
          :effect="'fade'"
          :navigation="true"
          :modules="modules"
          class="mySwiper2"
        >
        <swiper-slide class="whatour-slider">
          <div class="whatour-slider_img">
            <img src="../assets/img/home-page/whatour-slider.png" alt="">
          </div>
          <div class="whatour-slider_main">
            <h5>Laura Chaisson</h5>
            <p>In irure et ipsum eiusmod adipisicing id elit cillum proident. Adipisicing ullamco nisi veniam occaecat id excepteur ad non. Sunt occaecat elit ullamco commodo exercitation. Anim mollit irure Lorem proident veniam excepteur non irure Lorem. Lorem esse sint in nisi id esse.</p>
          </div>
        </swiper-slide>
        <swiper-slide class="whatour-slider">
          <div class="whatour-slider_img">
            <img src="../assets/img/home-page/whatour-slider.png" alt="">
          </div>
          <div class="whatour-slider_main">
            <h5>Laura Chaisson</h5>
            <p>In irure et ipsum eiusmod adipisicing id elit cillum proident. Adipisicing ullamco nisi veniam occaecat id excepteur ad non. Sunt occaecat elit ullamco commodo exercitation. Anim mollit irure Lorem proident veniam excepteur non irure Lorem. Lorem esse sint in nisi id esse.</p>
          </div>
        </swiper-slide>
        <swiper-slide class="whatour-slider">
          <div class="whatour-slider_img">
            <img src="../assets/img/home-page/whatour-slider.png" alt="">
          </div>
          <div class="whatour-slider_main">
            <h5>Laura Chaisson</h5>
            <p>In irure et ipsum eiusmod adipisicing id elit cillum proident. Adipisicing ullamco nisi veniam occaecat id excepteur ad non. Sunt occaecat elit ullamco commodo exercitation. Anim mollit irure Lorem proident veniam excepteur non irure Lorem. Lorem esse sint in nisi id esse.</p>
          </div>
        </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>

// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue';

// Import Swiper styles
import 'swiper/css';

import "swiper/css/navigation";

//import "./style.css";

import { Navigation } from "swiper";

export default {
    
    components: {
      Swiper,
      SwiperSlide,
    },
    setup() {
      return {
        modules: [Navigation],
      };
    },
}
</script>
<style lang="scss">

@import '../assets/scss/breakpoints.scss';


                                            //WHATOUR

.whatour {
  margin-top: 220px;
  @include breakpoints(md){
    margin-top: 160px;
  }
  @include breakpoints(sm){
    margin-top: 80px;
  }

  h2{
    font-family: 'Gilroy700';
    font-size: 45px;
    line-height: 140.5%;
    color: #41456B;
    @include breakpoints(sm){
      font-size: 30px;
    }
  }
}
.whatour-main {
  margin-top: 60px;
  background: #FFFFFF;
  box-shadow: 0px 20px 25px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  @include breakpoints(sm){
    margin-top: 30px;
  }
}
.mySwiper2{
  .swiper-button-next{
  background-image: url(../assets/img/home-page/arrow-next2.png);
  background-repeat: no-repeat;
  width: 53px;
  height: 53px;
  background-size: 100% 100%;
  right: 0;
  @include breakpoints(sm){
    width: 35px;
    height: 35px;
    top: 40%;
  }

  &::after{
    display: none;
  }
}
.swiper-button-prev{
  background-image: url(../assets/img/home-page/arrow-prev2.png);
  background-repeat: no-repeat;
  width: 53px;
  height: 53px;
  background-size: 100% 100%;
  left: 0;
  @include breakpoints(sm){
    width: 35px;
    height: 35px;
    top: 40%;
  }

  &::after{
    display: none;
  }
}
}
.whatour-slider {
  display: flex;
  gap: 40px;
  background: #FFFFFF;
  box-shadow: 0px 20px 25px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  justify-content: space-between;
  @include breakpoints(lg){
    align-items: center;
    gap: 0px;
  }
  @include breakpoints(md){
    flex-direction: column;
    gap: 20px;
  }

  &_img{
      // background-image: url(../assets/img/home-page/whatour-slider.png);
      // background-size: 100% 100%;
      width: 40%;
      @include breakpoints(lg){
        width: 45%;
      }
      @include breakpoints(md){
        width: 100%;
      }

      img{
        width: 100%;
        height: 100%;
      }
  }

  &_main{
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 11px;
    width: 60%;
    margin-right: 55px;
    @include breakpoints(lg){
      width: 45%;
      display: -webkit-box;
      -webkit-line-clamp: 6;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    @include breakpoints(md){
      -webkit-line-clamp: 8;
      width: 100%;
      margin-right: 0;
      margin-bottom: 40px;
      padding: 0 40px;
    }
    @include breakpoints(sm){
      margin-bottom: 20px;
      padding: 0 20px;
    }

    h5{
      font-family: 'Gilroy400';
      font-size: 16px;
      line-height: 180%;
      letter-spacing: 0.02em;
      color: #606276;
    }

    p{
      font-family: 'Gilroy600';
      font-size: 20px;
      line-height: 25px;
      color: #41456B;
    }
  }
}
    
</style>